var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tariff-history', {
    attrs: {
      "profileTariff": _vm.tariff,
      "loading": _vm.isFetching,
      "sort": _vm.sort,
      "history": _vm.sortedHistory,
      "products": _vm.products
    },
    on: {
      "sort": _vm.sorting,
      "tariff-closed": _vm.fetchProducts
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3770e592","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/tariffHistory/TariffHistoryContainer.vue
// module id = 985
// module chunks = 0